import { createFileRoute } from '@tanstack/react-router';
import { JourneysPage } from '@web/modules/campaigns/journeys/journeys-page';

export const Route = createFileRoute('/_app/campaigns/journeys/')({
  component: JourneysPage,
});
